import React from "react";
import Icon from "../../../Icon/Sprite";
import {ICONS} from "src/assets/sprite/iconsNames";
import {ImgComponent, substituteZeroWithLine} from "src/utils/utility";
import moment from "moment";
import GreyLogo from "../../../../assets/logo/logo-VT-grey.svg";

function ListInputMobileCandidature(props) {

    const {element} = props

    return (
        <div className="width-100">
            <div className="flex-between">
                <div className="flex-column">
                    <div className="blue underlined weight-700 size-16">{element.offertTitle}</div>
                    {element.anonymous ?
                        <div className="opacity-50 underlined size-12">
                            Azienda Anonima
                        </div>
                        :
                        <div className="opacity-50 underlined weight-400 size-12">
                            {element.uiCompanyLocationResponseData && element.uiCompanyLocationResponseData.name}
                        </div>}
                    <div className="flex-row dividerDot">
                        {element.offertInsertMode &&
                        <div className="flex-center">
                            {element.offertInsertMode}
                        </div>
                        }
                        {element.workPlace &&
                        <div className="flex-center">
                            {element.workPlace}
                        </div>
                        }
                    </div>
                    <div className="flex-row dividerDot margin-bottom-20">
                        {element.location &&
                        <div className="flex-center">
                            {element.location}
                        </div>
                        }
                        {element.impegnoRichiesto &&
                        <div className="flex-center">
                            {element.impegnoRichiesto}
                        </div>
                        }
                    </div>
                    <div>
                        <Icon color="grey" name={ICONS.user_ok}
                              size={[20, 20]}/>
                        {substituteZeroWithLine(element && element.candidateCount)}
                    </div>
                </div>
                <div className="flex-column-between">
                    <div className="flex-end">
                        <div style={{height: "55px", width: "70px", marginBottom: "15px"}}>
                            {element.companyLogo ?
                                <ImgComponent logoPath={element.companyLogo}/>
                                :
                                <div className="noLogo">
                                    <img src={GreyLogo}/>
                                </div>
                            }
                        </div>
                    </div>
                    <div className="weight-400 size-12 opacity-50">
                        {
                            element.candidatureState && element.candidatureState === "none" ?
                                <div>
                                    <div className="flex-end">
                                        <div className="backgroundStatePending flex-center" style={{width: "70%", margin: "10px 0"}}>
                                            <span>attesa</span>
                                        </div>
                                    </div>
                                    <div className="flex-center">Applicato:</div>
                                    <span className="flex-end">{moment(element.candidatureSubmittedTimestamp).locale('it').format("DD-MMM-YYYY")}</span>
                                </div>
                                : element.candidatureState === "In attesa" ?
                                <div>
                                    <div className="backgroundStatePending flex-center" style={{width: "70%", margin: "10px 0"}}>
                                        <span>In attesa · visualizzato</span>
                                    </div>
                                    <div className="flex-center">Applicato:</div>
                                    <span className="flex-end">{moment(element.candidatureSubmittedTimestamp).locale('it').format("DD-MMM-YYYY")}</span>
                                </div>
                                : element.candidatureState === "Colloquio" ?
                                    <div>
                                        <div className="backgroundStateInterview flex-center" style={{width: "70%", margin: "10px 0"}}>
                                            <span>Colloquio</span>
                                        </div>
                                        <div className="flex-center">Applicato:</div>
                                        <span className="flex-end">{moment(element.candidatureSubmittedTimestamp).locale('it').format("DD-MMM-YYYY")}</span>
                                    </div>
                                    : element.candidatureState === "Preselezione" ?
                                        <div>
                                            <div className="backgroundStatePreselected flex-center" style={{width: "70%", margin: "10px 0"}}>
                                                <span>Preselezione</span>
                                            </div>
                                            <div className="flex-center">Applicato:</div>
                                            <span className="flex-end">{moment(element.candidatureSubmittedTimestamp).locale('it').format("DD-MMM-YYYY")}</span>
                                        </div>
                                        : element.candidatureState === "Selezionato" ?
                                            <div>
                                                <div className="backgroundStateSelected flex-center" style={{width: "70%", margin: "10px 0"}}>
                                                    <span>Selezionato</span>
                                                </div>
                                                <div className="flex-center">Applicato:</div>
                                                <span className="flex-end">{moment(element.candidatureSubmittedTimestamp).locale('it').format("DD-MMM-YYYY")}</span>
                                            </div>
                                            : element.candidatureState === "Rifiutato" ?
                                                <div>
                                                    <div className="backgroundStateReject flex-center" style={{width: "70%", margin: "10px 0"}}>
                                                        <span>Rifiutato</span>
                                                    </div>
                                                    <div className="flex-center">Applicato:</div>
                                                    <span className="flex-end">{moment(element.candidatureSubmittedTimestamp).locale('it').format("DD-MMM-YYYY")}</span>
                                                </div>
                                                : null
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ListInputMobileCandidature